















































import Vue from 'vue';
import Card from '~/components/profile/cards/Card.vue';
import Avatar from '~/components/skeletons/base/Avatar.vue';
import Loading from '~/components/skeletons/base/Loading.vue';
import Row from '~/components/skeletons/base/Row.vue';

export default Vue.extend({
    name: 'ProfileSkeleton',
    components: { Loading, Row, Card, Avatar },
});
